import React, { Fragment } from "react";
import Breadcrumb from "../common/breadcrumb";
import { Card, CardBody, CardHeader, Col, Container, Row } from "reactstrap";
import { useSelector } from "react-redux";
import RackBackForm from "./rackBackFrom";
const RackBackSettings = () => {
  const result = useSelector((state) => state.admin);
  const { loginAdmin } = result || {};
  const { role } = loginAdmin || {};
  return (
    <Fragment>
      <Breadcrumb title="RackBack Settings" parent="RackBack" />
      <Container fluid={true}>
        <Row>
          <Col sm="12">
            <Card>
              <CardHeader>
                <h5>RackBack Settings </h5>
              </CardHeader>
              <CardBody>
                <RackBackForm role={role} />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default RackBackSettings;
